import { CAT_COURIER_DELIVERY_SERVICES } from 'App/utils/Collections';

export default {
  category: CAT_COURIER_DELIVERY_SERVICES,
  filters: [],
  searchBarProp: 'name',
};
